import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-foreground-600 text-sm">
            编辑团队精心挑选的跨文化融合深度好文
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/fashion"
            className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}